<template>
    <div class="container" v-if="showPanel">
        <div v-if="!isShowChat" class="content">
            <div class="header-wrap">
                <img class="header-icon" :src="config.iconImg" />
                <p class="title">{{config.name}}</p>
                <p class="txt">{{config.description}}</p>
                <div class="qustion-wrap">
                    <div class="qustion-item" v-for="(item,index) in config.items" :key="index" @click="questionClick(item)">
                        <div class="left-box">
                            <img class="question-left" :src="require('../assets/images/question-left.png')" />
                            <p class="question">{{item}}</p>
                        </div>
                        <img class="arrow-right" :src="require('../assets/images/arrow-right.png')" />
                    </div>
                </div>
            </div>
            <div class="footer-wrap">
                <div class="footer-box">
                    <textarea v-model="userQustion" class="input" placeholder="输入内容" ></textarea>
                    <img @click="firstSend" class="send-btn" :src="require('../assets/images/send.png')" fit="cover" />
                </div>
            </div>
        </div>
        <div v-else class="chat-wrap">
            <div class="chat-box">
                <div v-for="(item,index) in chatList" :key="index">
                    <div v-if="item.type == 'assistant'" class="chat-ai">
                        <img class="ai-img" :src="config.iconImg" />
                        <div class="chat" v-if="item.htmlContent" v-html="item.htmlContent"></div>
                        <div class="chat" v-else >{{item.content}}</div>
                    </div>
                    <div v-else class="chat-member">
                        <div class="chat">{{item.content}}</div>
                    </div>
                </div>
            </div>
            <div class="footer-wrap">
                <div class="again-btn" @click="restart">重新开始对话</div>
                <div class="footer-box">
                    <textarea v-model="userQustion" class="input" placeholder="输入内容" ></textarea>
                    <img @click="send" class="send-btn" :src="require('../assets/images/send.png')" fit="cover" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { init, initAgent, saveChat } from '@/api/common'
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import Vue from 'vue';
// import { getQueryObject } from '@/api/utils';

export default {
    name: 'PreviewWebPlugin',
    components: {  },
    computed: {
       
    },
    data() {
        return {
            showPanel: false,
            config: {
                iconImg: '',
                name: '',
                description: '',
                items: [],
                introduct: '',
            },
            agentId: '',
            userInfo: {},
            isShowChat: false,

            chatList: [],

            userQustion: '',
        }
    },
    created() {
        // this.pluginCode = getQueryObject('agentId');
        this.agentId = '0a8cea99cc1242ccbbc8ff1f45e893b5';
        this.showPanel = true;
        this.init()
    
    },
    beforeDestroy() {
        
    },
    methods: {
        async init() {
            if (!this.agentId) return;

            try {
                // 初始化用户信息
                let storedUser = {}
                try{
                    storedUser = JSON.parse(localStorage.getItem('userInfo'))
                }catch(e){
                    storedUser = {}
                }

                this.token = storedUser.token || '';

                const userRes = await init({
                    agentId: this.agentId,
                    token: this.token
                });

                if (userRes?.data) {
                    localStorage.setItem('userInfo', JSON.stringify(userRes.data));
                    this.userInfo = userRes.data;
                }

                // 初始化智能体
                const agentRes = await initAgent({ id: this.agentId });
                if (agentRes?.data) {
                    this.config = agentRes.data;
                }

            } catch (error) {
                console.error('初始化失败：', error);
            }
        },
        async pushAndSave(msg) {
            this.chatList.push(msg); // 更新视图
            try {
                await saveChat(msg); // 异步保存
            } catch (e) {
                console.error('保存聊天失败:', e);
                msg.failed = true; // 可标记失败
            }
        },
        /** 点击问题列表的问题 **/
        async questionClick(question) {
            this.isShowChat = true;

            // 如果有开场白，先保存开场白
            if (this.config.introduct) {
                const introduct = {
                    content: this.config.introduct,
                    talkId: this.userInfo.talkId,
                    type: 'assistant',
                };
                await this.pushAndSave(introduct);
            }

            // 保存用户问题
            const info = {
                content: question,
                talkId: this.userInfo.talkId,
                type: 'user',
            };
            await this.pushAndSave(info);

            // 再去调用 AI 流式回答
            this.getAiAnswer(question);
        },
        async getAiAnswer(question) {
            const aiMsg = Vue.observable({
                content: '',
                htmlContent: '',  // Markdown 转 HTML
                talkId: this.userInfo.talkId,
                type: 'assistant'
            })

            this.chatList.push(aiMsg)

            const response = await fetch('https://yinheapi.yinheshujie.com/prod-api/api/aiTalk/aiAnswer', {
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Accept': 'text/event-stream',
                    'Authorization':this.userInfo.token
                },
                body: JSON.stringify({
                    talkId: this.userInfo.talkId,
                    reqContext: question
                })
            })

            const reader = response.body.getReader()
            const decoder = new TextDecoder()

            for (;;) {
                const { done, value } = await reader.read();
                if(done) break

                const chunk = decoder.decode(value, { stream: true })
                const lines = chunk.split('\n')


                lines.forEach(line => {
                    if(!line) return
                    try{
                        const json = JSON.parse(line.replace('data:', ''));
                        
                        aiMsg.content += json.data.CONTENT || '';
                        
                        // 流式实时渲染 Markdown
                        aiMsg.htmlContent = DOMPurify.sanitize(marked(aiMsg.content));
                        
                        this.scrollBottom();
                    }catch(e){
                        console.log(e)
                    }
                })
            }

            // 结束后只保存
            try{
                await saveChat(aiMsg)
            }catch(e){
                console.error(e)
            }
        },
        
        scrollBottom(){
            this.$nextTick(()=>{
                const box = this.$el.querySelector('.chat-box')
                if(box){
                    box.scrollTop = box.scrollHeight
                }
            })
        },
        async send(){
            let qustion = this.userQustion.trim()
            if(qustion){
                const userMsg = Vue.observable({
                    content: qustion,
                    talkId: this.userInfo.talkId,
                    type: 'user'
                })

                await this.pushAndSave(userMsg)
                this.userQustion = ''

                this.getAiAnswer(qustion)

                this.scrollBottom();
            }else{
                return
            }
        },
        async firstSend() {
            let question = this.userQustion.trim();
            if (!question) return;

            this.isShowChat = true;

            // 保存开场白
            if (this.config.introduct) {
                const introduct = {
                    content: this.config.introduct,
                    talkId: this.userInfo.talkId,
                    type: 'assistant',
                };
                await this.pushAndSave(introduct);
            }

            // 保存用户消息
            const userMsg = Vue.observable({
                content: question,
                talkId: this.userInfo.talkId,
                type: 'user'
            });
            await this.pushAndSave(userMsg);

            this.userQustion = '';

            // 获取 AI 回答
            try {
                await this.getAiAnswer(question);
            } catch (e) {
                console.error('获取 AI 回答失败:', e);
            }
        },
        restart(){
            this.userQustion = ''
            this.chatList = []
            this.isShowChat = false
            this.init()
        }
    }
};
</script>


<style lang="scss">
.container{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .content{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        .header-wrap{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            top: 20%;
            .header-icon{
                width: 72px;
                height: 72px;
                border-radius: 8px;
            }
            .title{
                font-size: 16px;
                margin-top: 16px;
            }
            .txt{
                font-size: 14px;
                color: #8789A0;
                padding: 0 16px;
                margin-top: 12px;
            }
            .qustion-wrap{
                width: 100%;
                height: 200px;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                .qustion-item{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 12px;
                    background: #F7F7FC;
                    border-radius: 8px;
                    padding: 14px 15px;
                    box-sizing: border-box;
                    cursor: pointer;
                    .left-box{
                        display: flex;
                        align-items: center;
                    }
                    .question-left{
                        display: flex;
                        align-items: center;
                        margin-right: 15px;
                    }
                    .question{
                        flex: 1;
                        font-size: 14px;
                        font-weight: bold;
                        margin-right: 15px;
                    }
                }
            }
        }
    }
    .footer-wrap{
        width: 100%;
        position: absolute;
        bottom: 5%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        
        .again-btn{
            font-size: 14px;
            color: #ffffff;
            padding: 6px 15px;
            background: #0E5FFF;
            border-radius: 4px;
            margin-bottom: 16px;
            cursor: pointer;
        }
        .footer-box{
            width: 100%;
            box-shadow: 0px 0px 6px 1px rgba(177,183,229,0.9);
            border-radius: 8px;
            border: 1px solid #CED2E0;
            padding: 12px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }
        .send-btn{
            cursor: pointer;
        }
        .input{
            width: 100%;
            height: 100px;
            border: none;
        }
        .input:hover,
        .input:focus {
            border: none !important;
            outline: none !important;
        }
    }
    .chat-wrap{
        height: 100%;
        padding: 10px 0;
        position: relative;
        .chat-box{
            height: 70%;
            overflow-y: scroll;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE */
            .chat-ai{
                display: flex;
                align-items: flex-start;
                margin-top: 16px;
                .ai-img{
                    width: 40px;
                    height: 40px;
                    border-radius: 8px;
                    margin-right: 8px;
                }
            }
            .chat-member{
                margin-top: 16px;
                display: flex;
                justify-content: flex-end;
            }
            .chat{
                background: #F7F7FC;
                border-radius: 8px;
                font-size: 14px;
                padding: 10px 16px;
            } 
        }
        .chat-box::-webkit-scrollbar{
            display: none; /* Chrome Safari */
        }
    }
}
</style>